<template>
  <div class="OrganizationCopyCard card">
    <div class="card__section">
      <h5 class="text-blue text-upper text-small">
        <span class="text-small">{{ label }}</span>
      </h5>

      <div
        v-if="content && content.length > 0"
        class="OrganizationCopyCard__EmbeddedContent with high specificity"
        v-html="content"
      />
      <div v-else>
        <span class="OrganizationCopyCard__NoContent">(no content for this copy)</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'OrganizationCopyCard',
  props: {
    label: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../styles/variables';
@import '../../styles/mixins/cards';

.card {
  @include card;
}

.OrganizationCopyCard {
  margin-bottom: 24px;
}

.OrganizationCopyCard__NoContent {
  font-style: italic;
}

.OrganizationCopyCard__EmbeddedContent.with.high.specificity * {
  margin: 0;
  padding: 0;
}

.OrganizationCopyCard__EmbeddedContent.with.high.specificity ul > li {
  margin-left: 22px;
}

.OrganizationCopyCard__EmbeddedContent.with.high.specificity ol > li {
  margin-left: 22px;
}

</style>
